import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/icons/score-icon.svg'
import _imports_1 from '../assets/icons/irr-icon.svg'
import _imports_2 from '../assets/icons/benchmark-irr-icon.svg'
import _imports_3 from '../assets/icons/money-analysed-icon.svg'


const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = {
  key: 0,
  class: "pl-1 grey--text text--darken-1"
}
const _hoisted_3 = { class: "key-stat-illustration" }
const _hoisted_4 = { class: "card-text" }
const _hoisted_5 = { class: "stat-title" }
const _hoisted_6 = {
  key: 0,
  class: "counter-symbol"
}
const _hoisted_7 = { class: "stat-desc" }
const _hoisted_8 = { class: "key-stat-illustration" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = { class: "stat-title" }
const _hoisted_11 = { class: "stat-desc" }
const _hoisted_12 = { class: "key-stat-illustration" }
const _hoisted_13 = { class: "card-text" }
const _hoisted_14 = {
  key: 0,
  class: "stat-title"
}
const _hoisted_15 = { class: "counter-symbol" }
const _hoisted_16 = {
  key: 1,
  class: "stat-title"
}
const _hoisted_17 = { class: "stat-desc" }
const _hoisted_18 = { class: "key-stat-illustration" }
const _hoisted_19 = { class: "card-text" }
const _hoisted_20 = {
  key: 0,
  class: "stat-title"
}
const _hoisted_21 = {
  key: 1,
  class: "stat-title"
}
const _hoisted_22 = { class: "stat-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_counter = _resolveComponent("v-counter")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "KEY STATS", -1)),
      (_ctx.selectionCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.selectionCount) + " out of " + _toDisplayString(_ctx.totalCount) + " selected)", 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_layout, { class: "key-stat my-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: 6,
              md: 6,
              lg: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pa-3",
                      style: {"min-width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: _normalizeClass(["d-flex stat-card stat-card-1 pa-4", { 'stat-card--active': _ctx.statsAreActive }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "align-content": "center",
                              justify: "center",
                              "justify-lg": "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 5,
                                  md: 5,
                                  lg: 5,
                                  "align-self": "center",
                                  class: "text-center pa-0 d-none d-md-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, [
                                      _createVNode(_component_v_img, {
                                        class: "key-stat-illustration__image",
                                        src: _imports_0
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 7,
                                  md: 7,
                                  lg: 7,
                                  "align-self": "center",
                                  class: "text-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                      _createElementVNode("h1", _hoisted_5, [
                                        _createVNode(_component_v_counter, {
                                          startVal: _ctx.oldData ? _ctx.oldData.stat1_title : 0,
                                          endVal: _ctx.data.stat1_title,
                                          formatter: (n) => (_ctx.type == 'dataQuality' ? _ctx.formatNumber(n, '0.0') : _ctx.formatNumber(n, '0')),
                                          duration: 750
                                        }, null, 8, ["startVal", "endVal", "formatter"]),
                                        (_ctx.type == 'dataQuality')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "%"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_7, [
                                        _createTextVNode(_toDisplayString(_ctx.data.stat1_text) + " ", 1),
                                        (_ctx.tooltipVisibility)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              location: "bottom",
                                              "content-class": "tooltip-text"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  color: "#fff",
                                                  small: ""
                                                }, props), {
                                                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                    _createTextVNode("fa fa-info-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Value achieved against the benchmark", -1))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: 6,
              md: 6,
              lg: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pa-3",
                      style: {"min-width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: _normalizeClass(["d-flex stat-card stat-card-2 pa-4", { 'stat-card--active': _ctx.statsAreActive }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "align-content": "center",
                              justify: "center",
                              "justify-lg": "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 5,
                                  md: 5,
                                  lg: 5,
                                  "align-self": "center",
                                  class: "text-center pa-0 d-none d-md-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_v_img, {
                                        class: "key-stat-illustration__image",
                                        src: _imports_1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 7,
                                  md: 7,
                                  lg: 7,
                                  "align-self": "center",
                                  class: "text-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createElementVNode("h1", _hoisted_10, [
                                        _createVNode(_component_v_counter, {
                                          startVal: _ctx.oldData ? _ctx.oldData.stat2_title : 0,
                                          endVal: _ctx.data.stat2_title,
                                          formatter: (n) => _ctx.formatNumber(n * 100, '0.00'),
                                          duration: 750
                                        }, null, 8, ["startVal", "endVal", "formatter"]),
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "counter-symbol" }, "%", -1))
                                      ]),
                                      _createElementVNode("div", _hoisted_11, [
                                        _createTextVNode(_toDisplayString(_ctx.data.stat2_text) + " ", 1),
                                        (_ctx.tooltipVisibility)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              location: "bottom",
                                              "content-class": "tooltip-text"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  color: "#fff",
                                                  small: ""
                                                }, props), {
                                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                    _createTextVNode("fa fa-info-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "Average annual return over the period of investment", -1))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: 6,
              md: 6,
              lg: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pa-3",
                      style: {"min-width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: _normalizeClass(["d-flex stat-card stat-card-3 pa-4", { 'stat-card--active': _ctx.statsAreActive }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "align-content": "center",
                              justify: "center",
                              "justify-lg": "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 5,
                                  md: 5,
                                  lg: 5,
                                  "align-self": "center",
                                  class: "text-center pa-0 d-none d-md-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_v_img, {
                                        class: "key-stat-illustration__image",
                                        src: _imports_2
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 7,
                                  md: 7,
                                  lg: 7,
                                  "align-self": "center",
                                  class: "text-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, [
                                      (_ctx.type === 'vfm')
                                        ? (_openBlock(), _createElementBlock("h1", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.valueSign || ''), 1),
                                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "counter-symbol" }, "£", -1)),
                                            _createVNode(_component_v_counter, {
                                              startVal: _ctx.oldData ? _ctx.oldData.stat3_title : 0,
                                              endVal: _ctx.data.stat3_title,
                                              formatter: (n) => _ctx.formatNumber(n, '0.00a'),
                                              duration: 750
                                            }, null, 8, ["startVal", "endVal", "formatter"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("h1", _hoisted_16, [
                                            _createVNode(_component_v_counter, {
                                              startVal: _ctx.oldData ? _ctx.oldData.stat3_title : 0,
                                              endVal: _ctx.data.stat3_title,
                                              formatter: (n) => _ctx.formatNumber(n * 100, '0.00'),
                                              duration: 750
                                            }, null, 8, ["startVal", "endVal", "formatter"]),
                                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "counter-symbol" }, "%", -1))
                                          ])),
                                      _createElementVNode("div", _hoisted_17, [
                                        _createTextVNode(_toDisplayString(_ctx.data.stat3_text) + " ", 1),
                                        (_ctx.tooltipVisibility)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              location: "bottom",
                                              "content-class": "tooltip-text"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  color: "#fff",
                                                  small: ""
                                                }, props), {
                                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                    _createTextVNode("fa fa-info-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Average annual return with same contributions invested in benchmark index", -1))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: 6,
              md: 6,
              lg: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pa-3",
                      style: {"min-width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: _normalizeClass(["d-flex stat-card stat-card-4 pa-4", { 'stat-card--active': _ctx.statsAreActive }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "align-content": "center",
                              justify: "center",
                              "justify-lg": "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 5,
                                  md: 5,
                                  lg: 5,
                                  "align-self": "center",
                                  class: "text-center pa-0 d-none d-md-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_v_img, {
                                        class: "key-stat-illustration__image",
                                        src: _imports_3
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: 7,
                                  md: 7,
                                  lg: 7,
                                  "align-self": "center",
                                  class: "text-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_19, [
                                      (_ctx.type === 'dataQuality')
                                        ? (_openBlock(), _createElementBlock("h1", _hoisted_20, [
                                            _createVNode(_component_v_counter, {
                                              startVal: _ctx.oldData ? _ctx.oldData.stat4_title : 0,
                                              endVal: _ctx.data.stat4_title,
                                              formatter: (n) => _ctx.formatNumber(n, '0,00'),
                                              duration: 750
                                            }, null, 8, ["startVal", "endVal", "formatter"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("h1", _hoisted_21, [
                                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "counter-symbol" }, "£", -1)),
                                            _createVNode(_component_v_counter, {
                                              startVal: _ctx.oldData ? _ctx.oldData.stat4_title : 0,
                                              endVal: _ctx.data.stat4_title,
                                              formatter: (n) => _ctx.formatNumber(n, '0.00a'),
                                              duration: 750
                                            }, null, 8, ["startVal", "endVal", "formatter"])
                                          ])),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createTextVNode(_toDisplayString(_ctx.data.stat4_text) + " ", 1),
                                        (_ctx.tooltipVisibility)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              location: "bottom",
                                              "content-class": "tooltip-text"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  color: "#fff",
                                                  small: ""
                                                }, props), {
                                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createTextVNode("fa fa-info-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Total value of pots analysed", -1))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}